import { render, staticRenderFns } from "./QuizContainer.vue?vue&type=template&id=245d6d89"
import script from "./QuizContainer.vue?vue&type=script&lang=js"
export * from "./QuizContainer.vue?vue&type=script&lang=js"
import style0 from "./QuizContainer.vue?vue&type=style&index=0&id=245d6d89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports